<template>
  <div class="btn-wrap " :class="innerClass" v-if="!isEmpty(singleText) && !noWrapBtn && !modalBtn" :style="innerStyle">
    <button class="btn" :class="btnInnerClass" @click="fnEvent">{{ singleText }}</button>
  </div>

  <div class="btn-wrap " :class="innerClass" v-if="!isEmpty(leftText) && !modalBtn" :style="innerStyle">
    <button class="btn" :class="leftInnerClass ? leftInnerClass : ''" @click="fnLeftEvent">
      {{ leftText }}
    </button>
    <button class="btn" :class="rightInnerClass ? rightInnerClass : ''" @click="fnRightEvent">{{ rightText }}</button>
  </div>

  <div class="modal-btn" v-if="modalBtn" :style="innerStyle">
    <div class="btn-wrap">
      <button
        class="btn border-gray"
        :class="leftInnerClass ? leftInnerClass : ''"
        @click="fnLeftEvent"
        v-if="isEmpty(singleText)"
      >
        {{ leftText }}
      </button>
      <button
        class="btn"
        :class="rightInnerClass ? rightInnerClass : ''"
        @click="isEmpty(singleText) ? fnRightEvent() : fnEvent()"
      >
        {{ rightText || singleText }}
      </button>
    </div>
  </div>

  <button v-if="noWrapBtn" class="btn" @click="fnEvent" :class="innerClass">{{ singleText }}</button>
  <button v-if="uploadText" class="btn border-primary regular" @click="fnFileInput">
    <i class="ico-camera-primary"></i>{{ uploadText }}
    <input type="file" ref="fileInput" @change="fnUpload" style="display: none" />
  </button>
</template>
<script setup>
import { isEmpty } from '@/common/utils/Util';
import { ref } from 'vue';

const emits = defineEmits(['click', 'leftEvent', 'rightEvent', 'change', 'update:modelValue']);

const props = defineProps({
  singleText: {
    type: String,
    default: ''
  },
  leftText: {
    type: String,
    default: ''
  },
  rightText: {
    type: String,
    default: ''
  },
  modalBtn: {
    type: Boolean,
    default: false
  },
  btnInnerClass: {
    type: String,
    default: ''
  },
  innerClass: {
    type: String,
    default: ''
  },
  innerStyle: {
    type: String,
    default: ''
  },
  noWrapBtn: {
    type: Boolean,
    default: false
  },
  leftInnerClass: {
    type: String,
    default: 'border-gray'
  },
  rightInnerClass: {
    type: String,
    default: ''
  },
  uploadText: {
    type: String,
    default: ''
  },
  modelValue: {
    type: [Object, String],
    default: null
  }
});

const fileInput = ref(null);

const fnFileInput = () => {
  fileInput.value.click();
};
const fnUpload = event => {
  const files = event.target.files;
  if (isEmpty(files)) return;
  files[0].url = URL.createObjectURL(files[0]);
  emits('update:modelValue', files[0]);
};

const fnEvent = event => {
  event?.preventDefault?.();
  event?.stopPropagation?.();
  emits('click', event);
};

const fnLeftEvent = event => {
  event?.preventDefault?.();
  event?.stopPropagation?.();
  emits('leftEvent', event);
};

const fnRightEvent = event => {
  event?.preventDefault?.();
  event?.stopPropagation?.();
  emits('rightEvent', event);
};
</script>

<style scoped></style>
